/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  appList: [],
  oneInsightPerm: [],
};

const config = createSlice({
  name: "main",
  initialState: { ...initialState },
  reducers: {
    setAppList: (state, action) => {
      state.appList = action.payload;
    },
    setOneInsightPerm: (state, action) => {
      state.oneInsightPerm = action.payload;
    },
  },
});
const { reducer, actions } = config;

export const getMainState = (state) => state.main;

export const { setAppList, setOneInsightPerm } = actions;
export default reducer;
